import axiosWrapper from '@/utils/request'

const verifyToken = (token) => {
  return axiosWrapper({
    method: 'POST',
    url: `/v2/business/contacts/verify_digilocker_kyc_token`,
    data: {
      token: token
    }
  })
}

const submitConsent = (contactId, token) => {
  return axiosWrapper({
    method: 'POST',
    url: `/v2/business/contacts/generate_digilocker_kyc_link`,
    data: {
      contact_id: contactId,
      token: token,
      redirect_url: '/',
      consent: 'Y'
    }
  })
}

export default {
  verifyToken,
  submitConsent
}
